import React, { ReactElement, useState } from 'react';
import useLocale from '../../hooks/use-locale';
import SearchField from '../../components/inputs/search-field';
import IconButton from '../../components/buttons/icon-button';
import { FileUploadOutlined, ReplayOutlined } from '@mui/icons-material';
import AssetUpload from '../asset/asset-upload';
import { AssetGroup } from '../../types/assets.d';
import { useStoreValue } from '../../hooks/use-store-value';
import CanvasSelectors from '../../stores/selectors/canvas';
import Modal from '../../components/modal/modal';
import { useServices } from '../../hooks/use-services';
import { TemplateObjectChange } from '../../generated/gql/graphql';
import InstanceSelector from '../../stores/selectors/instance';

type Props = {
    onSearch: (input: string) => void;
};

export default function PackshotsHeader(props: Props): ReactElement {
    const { onSearch } = props;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [input, setInput] = useState<string>('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const selectedObjectId = useStoreValue<string>(CanvasSelectors.getSelectedObjectId());
    const currentInstance = useStoreValue<TemplateObjectChange | undefined>(
        InstanceSelector.getImagePropertyById(selectedObjectId),
    );

    const { getText } = useLocale();
    const { instance } = useServices();

    const [isUploadOpen, setIsUploadOpen] = useState(false);

    function handleOnChange(value: string): void {
        setInput(value);
        onSearch(value);
    }

    function handleOnOpen(): void {
        setIsModalOpen(true);
    }

    async function handleOnReset(): Promise<void> {
        setIsModalOpen(false);
        await instance.packshots.resetPackshot(selectedObjectId);
    }

    return (
        <>
            <SearchField
                placeholder={getText('widgets.packshotSelect.searchPlaceholder')}
                onChange={(v) => handleOnChange(v)}
            />
            <div className='mr-60 flex flex-row items-center gap-40'>
                <IconButton
                    className='max-h-34 max-w-34'
                    onClick={() => handleOnOpen()}
                    disabled={currentInstance === undefined}
                >
                    <ReplayOutlined className='fill-companyMediumGrey' />
                </IconButton>
                <IconButton className='max-h-34 max-w-34' onClick={() => setIsUploadOpen(true)}>
                    <FileUploadOutlined className='fill-companyMediumGrey' />
                </IconButton>
            </div>
            <AssetUpload
                open={isUploadOpen}
                onClose={() => setIsUploadOpen(false)}
                headline={getText('widgets.assetUpload.packshot.headline')}
                assetGroup={AssetGroup.Packshot}
            />
            <Modal
                onClose={() => setIsModalOpen(false)}
                open={isModalOpen}
                title={getText('widgets.packshotSelect.resetModal.headline')}
                onSubmit={() => handleOnReset()}
                actions={[
                    {
                        id: 'reset',
                        label: getText('widgets.packshotSelect.resetModal.confirm'),
                    },
                ]}
            >
                <p>{getText('widgets.packshotSelect.resetModal.content')}</p>
            </Modal>
        </>
    );
}
